import api from 'services/api';
import auth from 'services/auth';

export const SESSION_FETCH = 'session/fetch';
export const SESSION_UPDATE = 'session/update';

const actions = {
  fetch() {
    return {
      type: SESSION_FETCH,
      payload: api.get('/session').then((session) => {
        auth.setSession(session);
        return session;
      }),
    };
  },
};

export const initialState = {};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case SESSION_FETCH:
    case SESSION_UPDATE:
      return action.payload;

    default:
      return state;
  }
}

export default actions;
